import { MediaType } from '../../../core/common/enum';

export abstract class BlocEvent {
}

export class InitEvent<T> extends BlocEvent {
  constructor(public args?: T) {
    super();
  }
}

export class LoadEvent<T> extends BlocEvent {}

export class SubmitEvent<T> extends BlocEvent {
  constructor(public item: T) {
    super();
  }
}

export class ExportReportEvent<T> extends BlocEvent {
  constructor(public item: T) {
    super();
  }
}

export class SearchEvent extends BlocEvent {
  constructor(public phrase: string) {
    super();
  }
}

export class UploadMediaEvent extends BlocEvent {
  constructor(public file: File, public type?: MediaType) {
    super();
  }
}

